import BsDashLg from '../icons/BsDashLg';
import BsPlusLg from '../icons/BsPlusLg';
import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import '../styles/InputQuantity.css';


/*
 * A component for displaying a custom input for quantities.
 * @component
 */
const InputQuantity = ({disabled = false, max, quantity, setQuantity}) => {
    /** References */
    const quantityInput = useRef(null);

    /** Event Handlers */
    const onChangeQuantity = (e) => setQuantity(parseInt(e.target.value));
    const onClickDecrement = () => setQuantity(quantity < 2 ? 1 : quantity - 1);
    const onClickIncrement = () => setQuantity(typeof max !== 'number'
        ? quantity + 1
        : (quantity >= max ? quantity : quantity + 1)
    );

    return (<div
        className={'input-quantity--container'}>
        <Button
            className={'input-quantity--action-button'}
            disabled={disabled || quantity < 2}
            onClick={onClickDecrement}
        >
            <BsDashLg
                size={'2rem'}
                strokeWidth={'1px'} />
        </Button>
        <input
            className={'input-quantity--input-box'}
            disabled={disabled}
            name={'quantity'}
            ref={quantityInput}
            type={'number'}
            value={quantity}
            onChange={onChangeQuantity}
            {...Math.min(1, max) > -1 && ({ min: Math.min(1, max) })}
            {...max > 0 && ({ max })}
        />
        <Button
            className={'input-quantity--action-button'}
            disabled={disabled || (typeof max === 'number' && quantity >= max)}
            onClick={onClickIncrement}
        >
            <BsPlusLg
                size={'2rem'}
                strokeWidth={'1px'} />
        </Button>
    </div>);
};

/** Prop Types */
InputQuantity.propTypes = {
    /** Indicate whether the input and buttons should be disabled. */
    disabled: PropTypes.bool,
    /** The maximum quantity that can be set in the input. */
    max: PropTypes.number,
    /** The `quantity` state from the parent component. */
    quantity: PropTypes.number,
    /** The setter for the `quantity` state in the parent component. */
    setQuantity: PropTypes.func,
};

export default InputQuantity;
